import { cachedJSON } from '../utils/cachedJSON.js';
import { useState, useEffect } from 'react';

// Fetches the unifying datasheet payload from GET /api/satellites/:norad/datasheet
// (Phase 5 endpoint). Shape: { norad_id, fields: { identity, classification,
// launch, mass_and_dimensions, operations, orbit, status }, images, references,
// sources_available, generated_at }. See orbitalglass-api/src/datasheet.js for
// the precedence rules and field semantics.
//
const API = import.meta.env.VITE_API_BASE || '/api';

export function useDatasheet(norad) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  useEffect(() => {
    if (!Number.isFinite(norad)) { setData(null); setError(null); setLoading(false); return; }
    let cancelled = false;
    setData(null);
    setLoading(true);
    setError(null);
    cachedJSON(`${API}/satellites/${norad}/datasheet`, {ttl:300000})
      .then(d => { if (!cancelled) { setData(d); setLoading(false); } })
      .catch(e => { if (!cancelled) { setError(e.message); setData(null); setLoading(false); } });
    return () => { cancelled = true; };
  }, [norad]);

  return { data, loading, error };
}